import React from "react";

const AssignEmployees = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M16.22 21.585v12.052H4c0-3.196 1.288-6.262 3.58-8.522 2.291-2.26 5.4-3.53 8.64-3.53zm0-1.507c-5.063 0-9.165-4.045-9.165-9.039S11.157 2 16.221 2s9.165 4.045 9.165 9.04c0 4.993-4.101 9.038-9.165 9.038zM30.311 26.32h.711c.189 0 .37.067.503.187a.61.61 0 01.208.453v6.4a.61.61 0 01-.208.453.753.753 0 01-.503.187H19.644a.753.753 0 01-.502-.188.61.61 0 01-.209-.452v-6.4a.61.61 0 01.209-.453.753.753 0 01.502-.187h.712v-.64c0-.588.128-1.17.378-1.714a4.48 4.48 0 011.08-1.454 5.046 5.046 0 011.614-.971 5.463 5.463 0 011.905-.341c.654 0 1.301.116 1.905.341a5.047 5.047 0 011.615.971c.462.416.829.91 1.08 1.454.25.543.378 1.126.378 1.714v.64zm-1.422 0v-.64c0-.849-.375-1.663-1.041-2.263-.667-.6-1.572-.937-2.515-.937-.943 0-1.847.337-2.514.937-.667.6-1.041 1.414-1.041 2.263v.64h7.11zm-4.267 2.56v2.56h1.422v-2.56h-1.422z"
            fill={fill}
        />
    </svg>
);

export default AssignEmployees;
